import React, { useEffect, useState,useCallback } from "react";
import { Tabs, List } from "antd";
import { firestore } from "../../config/firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import UserReviews from "./userReviews";
import SessionsLogs from "./session_logs";
import { useLocation } from "react-router-dom";
import CounsellorProfile from "./counsellorProfile";
import moment from "moment";
const { TabPane } = Tabs;
const items = [
  {
    key: "1",
    label: "Counsellor Profile",
    children: "Counsellor Profile",
  },
  {
    key: "2",
    label: "Counsellor Reviews",
    children: "Counsellor Reviews",
  },
  {
    key: "3",
    label: "All Session List",
    children: "All Session List",
  },
  {
    key: "4",
    label: "Call Session",
    children: "Call Session",
  },
  {
    key: "5",
    label: "Chat Session",
    children: "Chat Session",
  },
];

const CounsellorTabs = () => {
  
  const [activeTab, setActiveTab] = useState("1");
  const [chatData, setChatData] = useState([]);
  const [userMessages, setUserMessages] = useState([]);
  const [users, setUsers] = useState({});
  const [counsellor, setCounsellor] = useState({});
  const [logs, setLogs] = useState([]);
  const [dummy, setDummy] = useState([]);
  const [logList, setLogList] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [review,setReviewList]=useState([])
  const location = useLocation();
  const current_counsellor = location.state?.selectedUser || null;

  useEffect(() => {
    const fetchUsers = async () => {
      const usersCollection = collection(firestore, "users");
      const querySnapshot = await getDocs(usersCollection);
      const usersData = {};
      querySnapshot.forEach((doc) => {
        usersData[doc.id] = doc.data().firstName;
      });
      setUsers(usersData);
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      const counsellorCollection = collection(firestore, "councellors");
      const querySnapshot = await getDocs(counsellorCollection);
      const counsellorData = {};
      querySnapshot.forEach((doc) => {
        counsellorData[doc.id] = doc.data().firstName;
      });
      setCounsellor(counsellorData);
    };

    fetchUsers();
  }, []);

  const handleTabChange = (key) => {
    setActiveTab(key);
    setUserMessages([]);
    refreshData();
  };
  const refreshData = useCallback(() => {
    setLogList(dummy);
    setLogs(dummy);
  }, [activeTab]);


  const handleUserClick = async (userId) => {
    const userDocRef = doc(firestore, "users", userId);
    const userDocSnapshot = await getDoc(userDocRef);
    const filteredMessages = chatData.filter(
      (item) =>
        item.type === "counsellor" ||
        (item.type === "user" && item.receiver_id === userId)
    );
    setUserMessages(filteredMessages);
  };



  useEffect(() => {
    const fetchData = async () => {
      const userRef = doc(
        firestore,
        "counsellor_logs",
        current_counsellor.uuid
      );

      const feedbackRef= doc(
        firestore,
        "user_feedback",
        current_counsellor.uuid
      );

      const nestedRef = collection(feedbackRef, current_counsellor.uuid); // Replace with actual nested collection name
      const nestedData = await getDocs(nestedRef);
      const reviewList = nestedData.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setReviewList([...reviewList])

      const nestedCollectionRef = collection(userRef, current_counsellor.uuid); // Replace with actual nested collection name
      const nestedSnapshot = await getDocs(nestedCollectionRef);
      const nestedDocs = nestedSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
         setLogs(nestedDocs);
        setDummy(nestedDocs);
        setLogList(nestedDocs);
    };

    fetchData();

    return () => {};
  }, []);

  const handle_filter = (arg) => {
    if (activeTab === "3") {
      setLogs([
        ...dummy.filter((el) => {
          if (arg === "1") return el.type === "voice call";
          if (arg === "2") return el.type === "video call";
          if (arg === "3") return el.type === "chat";
          if (arg === "4") return el;
        }),
      ]);
    } else if (activeTab === "4") {
      setLogList([
        ...dummy.filter((el) => {
          if (arg === "1") return el.type === "voice call";
          if (arg === "2") return el.type === "video call";
          if (arg === "4") return el;
        }),
      ]);
    }
    if (arg !== "4") toggle_filter();
  };
  const toggle_filter = () => {
    setShowFilter(!showFilter);
  };

  const handleDateFilter = (dates) => {
    if (activeTab === "3") {
      if (dates) {
        const startDate = dates[0].format("YYYY-MM-DD");
        const endDate = dates[1].format("YYYY-MM-DD");
        const filteredData = dummy
          .map((el) => {
            el.date = moment(el.end_time).format("YYYY-MM-DD");
            return el;
          })
          .filter((item) => {
            const itemDate = moment(item.date, "YYYY-MM-DD");

            return itemDate.isBetween(startDate, endDate, null, "[]");
          });

        setLogs(filteredData);
      }
    } else {
      if (dates) {
        const startDate = dates[0].format("YYYY-MM-DD");
        const endDate = dates[1].format("YYYY-MM-DD");
        const filteredData = dummy
          .map((el) => {
            el.date = moment(el.end_time).format("YYYY-MM-DD");
            return el;
          })
          .filter((item) => {
            const itemDate = moment(item.date, "YYYY-MM-DD");

            return itemDate.isBetween(startDate, endDate, null, "[]");
          });

        setLogList(filteredData);
      }
    }
  };

  return (
    <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={handleTabChange}>
      {items.map((item) => (
        <TabPane tab={item.label} key={item.key}>
          {item.key === "1" ? (
            <CounsellorProfile
              logs={logs}
              callLogs={logs.filter((el) => el.type !=="chat")}
              chatLogs={logs.filter((el) => el.type === "chat")}
              videoLogs={logs.filter((el) => el.type === "video call")}
              voiceLogs={logs.filter((el) => el.type === "voice call")}
              reviews={review}
              activeTab={activeTab}
              handle_filter={handle_filter}
            />
          ) : item.key === "2" ? (
            <UserReviews reviews={review}/>
          ) : item.key === "3" ? (
            <SessionsLogs
              logs={logs}
              handle_filter={handle_filter}
              activeTab={activeTab}
              toggle_filter={toggle_filter}
              showFilter={showFilter}
              dummy={dummy}
              handleDateFilter={handleDateFilter}
              logList={logList}
            />
          ) : item.key === "4" ? (
            <SessionsLogs
              logs={logList.filter((el) => el.type !== "chat")}
              handle_filter={handle_filter}
              activeTab={activeTab}
              toggle_filter={toggle_filter}
              showFilter={showFilter}
              dummy={dummy}
              handleDateFilter={handleDateFilter}
              logList={logList}
            />
          ) : item.key === "5" ? (
            <SessionsLogs
              logs={logList.filter((el) => el.type === "chat")}
              handle_filter={handle_filter}
              activeTab={activeTab}
              toggle_filter={toggle_filter}
              showFilter={showFilter}
              dummy={dummy}
              handleDateFilter={handleDateFilter}
            />
          ) : (
            <div className="chat-container">
              {!current_counsellor && (
                <List
                  dataSource={chatData
                    .filter((item) => item.type === "user")
                    .reduce((acc, cur) => {
                      if (
                        !acc.find(
                          (item) => item.receiver_id === cur.receiver_id
                        )
                      ) {
                        acc.push(cur);
                      }
                      return acc;
                    }, [])}
                  renderItem={(item) => (
                    <List.Item
                      key={item.receiver_id}
                      onClick={() => handleUserClick(item.receiver_id)}
                    >
                      <List.Item.Meta
                        title={`User-${
                          users[item.receiver_id] || item.receiver_id
                        }`}
                        description="Click to view chat history"
                      />
                    </List.Item>
                  )}
                />
              )}
              {current_counsellor && (
                <List
                  dataSource={userMessages}
                  renderItem={(item) => (
                    <List.Item
                      className={`chat-message ${
                        item.type === "counsellor" ? "sender" : "receiver"
                      }`}
                      key={item.id}
                    >
                      <div className="message-content">
                        {item.type === "counsellor" && (
                          <p>
                            <strong>Counsellor:</strong>{" "}
                            {counsellor[item.sender_id] || item.sender_id}
                          </p>
                        )}
                        {item.type === "user" && (
                          <p>
                            <strong>User:</strong>{" "}
                            {users[item.receiver_id] || item.receiver_id}
                          </p>
                        )}
                        <span className="message-text">{item.message}</span>
                        <p>
                          <span className="message-timestamp">
                            {item.stamp.toDate().toString()}
                          </span>
                        </p>
                      </div>
                    </List.Item>
                  )}
                />
              )}
            </div>
          )}
          {/* </Container> */}
        </TabPane>
      ))}
    </Tabs>
  );
};

export default CounsellorTabs;
